export default {
  state: {
    searchFlag: false,
    selectedTabhref: '#my-details',
  },
  getters: {
    searchActive: state => state.searchFlag,
  },
  mutations: {
    showSearch(state, onlyHide = false) {
      if (onlyHide) {
        return (state.searchFlag = false)
      } else {
        return (state.searchFlag = !state.searchFlag)
      }
    },
    switchTab(state, selectedTabhref) {
      state.selectedTabhref = selectedTabhref

      return state.selectedTabhref
    },
  },
}
